import Drawer from '@/component/Drawer'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import InviteMain from './InviteMain'

const InvitePopup: React.FC<PropType> = () => {
  const { t } = useTranslation('invite')
  const invitePopupVisible = useStatePopup(PopupSelector.invitePopupVisible)

  const handleClose = () => {
    PopUpStore.setInvitePopupVisible(false)
  }

  return (
    <Drawer
      visible={invitePopupVisible}
      zIndex={903}
      onClose={handleClose}
      lockScroll={true}
      destroyOnClose
      className="bg-primary-light"
      title={t('modalTitle.invite')}
    >
      <InviteMain />
    </Drawer>
  )
}

interface PropType {}

export default InvitePopup
